import { atom } from 'jotai'
import { IOfferAffiliateNetwork } from '../types'

type IAffiliateNetworkOptionsState = Array<IOfferAffiliateNetwork> | null

const defaultState: IAffiliateNetworkOptionsState = null

// base atom with initial value
export const affiliateNetworkOptionsAtom = atom<IAffiliateNetworkOptionsState>(defaultState)